import type { AuthUser } from "@/auth/useAuth";
import type { RestClient } from "./restClient";

/** Auth-related endpoints routed through the shared REST client — so calls
 *  authenticate correctly under both the cookie SPA flow AND the embed
 *  bearer flow. The old `checkAuth()` helper used raw `fetch` with
 *  `credentials: "include"`, which silently 401s inside embeds (no cookie)
 *  and makes every permission gate fail closed. Use this instead. */
export class AuthApi {
  constructor(private client: RestClient) {}

  me(): Promise<AuthUser> {
    return this.client.get("/auth/me");
  }
}
